import { Domain } from '@app/core/models/domain';
import { License } from '@app/shared/models/license';

export function hasEnterpriseLicense(domain: Domain, license: License): boolean {
  let hasLicense: boolean = false;

  if (license === License.CallCenter) {
    hasLicense = domain.maxAcdAgents > 0 || domain.maxAcdSupervisors > 0;
  } else if (license === License.Conference) {
    hasLicense = domain.maxDedicatedConf > 0;
  } else if (license === License.IVR) {
    hasLicense = domain.maxIvrAssistants > 0;
  }

  return hasLicense;
}
